// @flow

import moment from "moment";

import createValueModule from "../create-value-module";

const MAX_INACTIVITY_DURATION = 30 * 60; // 30 minutes in SECONDS
const LONG_POLL_INTERVAL = 30 * 1000; // 1 minute in MILLISECONDS

const { reducer, actions } = createValueModule("inactivity", {
    timestamp: moment().unix(),
});

const checkInactivity = () => (dispatch: any, getState: any) => {
    if (
        moment().unix() - getState().inactivity.timestamp >=
        MAX_INACTIVITY_DURATION
    ) {
        dispatch(clear());
        return (window.location.href = "/api/user/logout");
    }
};

let timer = null;
export const startActivityPolling = () => (dispatch: any) => {
    clearInterval(timer);
    // eslint-disable-next-line
    return (timer = setInterval(
        () => dispatch(checkInactivity()),
        LONG_POLL_INTERVAL,
    ));
};

export const updateTimestamp = () => (dispatch: any) =>
    dispatch(set({ timestamp: moment().unix() }));

export default reducer;

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;
